import { List } from "@mui/material"
import { FC } from "react"
import type { DetailListItem } from "./DetailItem"
import DetailItem from "./DetailItem"

export interface DetailListProps {
  items: DetailListItem[]
  hasBorder?: boolean
  itemBorder?: boolean
}

const DetailList: FC<DetailListProps> = ({ items, hasBorder = true, itemBorder = true }) => {
  return (
    <>
      <List
        sx={{
          p: 0,
          border: hasBorder ? "1px solid #ddd" : undefined,
          borderRadius: hasBorder ? "6px" : undefined
        }}
      >
        {items?.map((item, index: number) => {
          return <DetailItem key={item.title} itemBorder={itemBorder} index={index} {...item} />
        })}
      </List>
    </>
  )
}

export default DetailList
